import React from 'react'

import { LeftImageContent, NoImageContent, RightImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { List, SectionTitle, Text } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const Insights: React.FC<SectionProps> = ({ copy, topicKey }) => {
  const contentCopy = copy.insights_widget_overview
  const contentMap = {
    'insights-widget-overview': (
      <React.Fragment>
        <Text content={contentCopy.widget_overview_description} />
        <NoImageContent
          content={
            <React.Fragment>
              <SectionTitle content={contentCopy.insights_work_section_title} />
              <Text content={contentCopy.insights_work_description} />
              <List
                items={[
                  buildDynamicCopy(
                    contentCopy.insights_work_list_1,
                    <b>{contentCopy.insights_work_list_1_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    contentCopy.insights_work_list_2,
                    <b>{contentCopy.insights_work_list_2_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    contentCopy.insights_work_list_3,
                    <b>{contentCopy.insights_work_list_3_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    contentCopy.insights_work_list_4,
                    <b>{contentCopy.insights_work_list_4_bold}</b>,
                  ) as React.ReactNode,
                ]}
                listType="ul"
              />
              <Text content={contentCopy.insights_work_content} sx={{ pt: 12 }} />
            </React.Fragment>
          }
          sx={{ pt: 8 }}
        />

        <SectionTitle content={contentCopy.dashboard_insights_section_title} sx={{ mt: 48 }} />
        <RightImageContent
          altImage={contentCopy.alt_image_dashboard_insights}
          content={
            <React.Fragment>
              <Text
                content={
                  buildDynamicCopy(
                    contentCopy.dashboard_insights_content_1,
                    <b>{contentCopy.dashboard_insights_content_1_bold_1}</b>,
                    <b>{contentCopy.dashboard_insights_content_1_bold_2}</b>,
                    <b>{contentCopy.dashboard_insights_content_1_bold_3}</b>,
                  ) as React.ReactNode
                }
              />
              <Text content={contentCopy.dashboard_insights_content_2} sx={{ pt: 12 }} />
            </React.Fragment>
          }
          image={HELP_IMAGES.INSIGHTS_CAROUSEL}
        />

        <SectionTitle content={contentCopy.full_feed_section_title} sx={{ mt: 48 }} />
        <LeftImageContent
          altImage={contentCopy.alt_image_full_feed}
          content={
            <React.Fragment>
              <Text
                content={
                  buildDynamicCopy(
                    contentCopy.full_feed_content,
                    <b>{contentCopy.full_feed_content_bold_1}</b>,
                    <b>{contentCopy.full_feed_content_bold_2}</b>,
                  ) as React.ReactNode
                }
              />
              <List
                items={[
                  buildDynamicCopy(
                    contentCopy.full_feed_list_1,
                    <b>{contentCopy.full_feed_list_1_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    contentCopy.full_feed_list_2,
                    <b>{contentCopy.full_feed_list_2_bold}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    contentCopy.full_feed_list_3,
                    <b>{contentCopy.full_feed_list_3_bold}</b>,
                  ) as React.ReactNode,
                ]}
                listType="ul"
              />
            </React.Fragment>
          }
          image={HELP_IMAGES.INSIGHTS_FEED}
          imageLargeBreakPoint={3}
        />

        <SectionTitle content={contentCopy.hide_insights_section_title} sx={{ mt: 48 }} />
        <NoImageContent
          content={
            <React.Fragment>
              <Text
                content={
                  buildDynamicCopy(
                    contentCopy.hide_insights_content_1,
                    <b>{contentCopy.hide_insights_content_1_bold}</b>,
                  ) as React.ReactNode
                }
              />
              <Text content={contentCopy.hide_insights_content_2} sx={{ pt: 12 }} />
            </React.Fragment>
          }
          hasDivider={false}
        />
      </React.Fragment>
    ),
  }
  return contentMap[topicKey as keyof typeof contentMap]
}

export default Insights
